module.exports = __webpack_public_path__ + "img/setrow-logo.9496d55c.svg";